import React from 'react';
import { RouterLink } from '../../../../components';
import styles from './SamlLink.module.scss';

export const SamlLink = props => {
  return (
    <p data-test-block="samlLink" className={styles.samlLink}>
      <RouterLink data-test-link="samlLink" to={props.samlLink}>
        <b>Log in with Single Sign On</b>
      </RouterLink>
    </p>
  );
};
